<div class="flex pb-0 pt-[0px] overflow-hidden">
  <div class="w-[100%] pr-[10px]">
    <!-- Questions List -->
    <div class="bg-white overflow-hidden">
      <div class="toolbar-content">
        <mat-checkbox></mat-checkbox>
        <button mat-icon-button>
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <button mat-icon-button>
          <mat-icon>refresh</mat-icon>
        </button>
        <button mat-icon-button>
          <mat-icon>more_vert</mat-icon>
        </button>
        <span class="spacer"></span>
        <div class="pagination">
          <span>1-50 of 100</span>
          <button mat-icon-button>
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>

      <div>
        <div *ngIf="formattedQueriesResponses?.answered">
          <div>
            <div
              *ngFor="
                let answeredGroup of formattedQueriesResponses?.answered
                  | keyvalue;
                let i = index
              "
            >
              <div class="flex items-center">
                <!-- TODO: -->
                <div
                  [ngClass]="
                    highlightedQueryKey === answeredGroup.key
                      ? 'bg-red-100 text-gray-700'
                      : ''
                  "
                  class="flex-grow cursor-pointer p-4 !pl-[2.9rem]"
                  (click)="toggleSelection(answeredGroup.key)"
                >
                  <div>
                    <div>
                      <div
                        class="flex items-start justify-between space-x-2"
                        *ngFor="
                          let question of getAnsweredGroup(answeredGroup)
                            ?.questions
                        "
                      >
                        <div class="flex items-start">
                          <span>
                            <img
                              [src]="question?.avatar"
                              alt="User avatar"
                              class="w-8 h-8 rounded-full"
                              height="32"
                              width="32"
                            />
                          </span>
                          <p
                            class="font-semibold !mb-0 !ml-2"
                            [innerHTML]="getSanitizedHtml(question?.question)"
                          ></p>
                        </div>
                        <div class="text-gray-500">{{ question?.date }}</div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="mt-2 !pl-[5rem]"
                    [ngClass]="{
                      hidden: highlightedQueryKey !== answeredGroup.key
                    }"
                  >
                    <div
                      [innerHTML]="getAnsweredGroup(answeredGroup)?.answer"
                    ></div>
                    <!--Picked Attach File from upload Drawings -->
                    <div
                      *ngIf="getAnsweredGroup(answeredGroup)?.files"
                      class="!max-h-[150px] overflow-y-auto"
                    >
                      <a
                        
                        *ngFor="
                          let file of getAnsweredGroup(answeredGroup)?.files;
                          let i = index
                        "
                        class="!ml-[20px] text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer  "
                        #downloadRfpResponseDocumentLink
                        [href]="docUrl || '#'"
                        (click)="
                          
                          downloadRfpResponseDocument(
                            $event,
                            downloadRfpResponseDocumentLink,
                            file?.id,
                            file?.filePath
                          )
                        "
                      >
                     <div class="flex bg-[#E76B3F] text-[#FFFFFF] rounded-full px-4 py-[5px] w-[16vw]">
                      <div
                      class="relative ml-[5px] mr-[5px] w-[1rem] h-[1rem] overflow-hidden"
                    >
                      <img
                        [src]="getFileIcon(file)"
                        alt="File Preview"
                        class="object-cover w-auto h-[100%] cursor-pointer"
                      />
                    </div>
                          <span>{{ file?.name?.length > 20 ? (file?.name | slice : 0:20) + '...' : file?.name }}</span>
                        </div>
                      </a>
                    </div>
                    <!--Picked Attach File from local system /pc -->
                    <div
                      *ngIf="getAnsweredGroup(answeredGroup)?.newFiles"
                      class="!max-h-[150px]  overflow-y-auto "
                    >
                      <ng-container *ngFor="
                        let newFile of getAnsweredGroup(answeredGroup)
                          ?.newFiles;
                        let i = index
                      ">
                      
                        <a
                        target="_blank"
                        class="!ml-[20px] text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer  "
                        #downloadRfpResponseDocumentLink
                        [href]="docUrl || '#'"
                        data="#"
                        (click)="$event.stopPropagation();
                        downloadRfpResponseDocument(
                          $event,
                          downloadRfpResponseDocumentLink,
                          newFile?.id,
                          newFile?.file_path
                        )">
                        <div class="flex items-center bg-[#E76B3F] text-[#FFFFFF] rounded-full px-4 py-[5px] w-[16vw]">
                          <div
                          class="relative ml-[5px] !mr-[5px] w-[1rem] h-[1rem] overflow-hidden"
                        >
                          <img
                            [src]="getFileIcon(newFile)"
                            alt="File Preview"
                            class="object-cover w-auto h-[100%] cursor-pointer"
                          />
                        </div>
                        {{ newFile?.title?.length > 20 ? (newFile?.title | slice:0:20) + '...' : newFile?.title }}
                        <!-- {{ newFile?.title?.split('.').pop() }} -->
                      </div></a>
                      </ng-container>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="formattedQueriesResponses?.pending?.questions">
          <div>
            <!-- <h6>Pending Queries</h6> -->
            <!-- Loop through pending questions -->
            <div
              *ngFor="
                let pendingQuery of formattedQueriesResponses?.pending
                  ?.questions;
                let i = index
              "
            >
              <div
                class="flex items-center p-4 !pl-0"
                [ngClass]="
                  highlightedQueryKey === i ? 'bg-red-100 text-gray-700' : ''
                "
                (click)="toggleSelection(i)"
              >
                <div class="flex">
                  <mat-checkbox
                    class="!pr-[7px] mt-[-3px]"
                    (change)="toggleQuerySelection($event, pendingQuery)"
                  ></mat-checkbox>
                  <div>
                    <img
                      [src]="pendingQuery?.avatar"
                      alt="User avatar"
                      class="w-8 h-8 rounded-full mr-[5px]"
                      height="32"
                      width="32"
                    />
                  </div>
                  <div
                    class="flex-grow cursor-pointer"
                    (click)="toggleDetails()"
                  >
                    <div class="flex items-start justify-between w-full">
                      <span
                        class="font-semibold !ml-[3px] flex-1"
                        [innerHTML]="getSanitizedHtml(pendingQuery.question)"
                      ></span>
                      <div class="text-gray-500 whitespace-nowrap ml-2">
                        {{ pendingQuery.date }}
                      </div>
                    </div>
                    <div class="flex items-center space-x-4 mt-2">
                      <div
                        class="text-[#000000] cursor-pointer flex items-center"
                        (click)="instantReply(pendingQuery)"
                      >
                        <mat-icon class="!ml-[10px] "
                          >reply</mat-icon
                        >
                        <span class="relative bottom-0.5">Reply</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
